export default {"src":"/_next/static/media/demographic-targeting.20b54cb1.svg","height":1369,"width":1152,"blurWidth":0,"blurHeight":0};